module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15EDK4O/tc-custom/9780814748343.jpg?1705023582411",
      "alt": "This image is the cover for the book Working the Diaspora, Culture, Labor, History"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Working the Diaspora, Culture, Labor, History\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From the sixteenth to early-nineteenth century, four times more Africans than Europeans crossed the Atlantic Ocean to the Americas. While this forced migration stripped slaves of their liberty, it failed to destroy many of their cultural practices, which came with Africans to the New World. In Working the Diaspora, Frederick Knight examines work cultures on both sides of the Atlantic, from West and West Central Africa to British North America and the Caribbean."), _c('br'), _vm._v("Knight demonstrates that the knowledge that Africans carried across the Atlantic shaped Anglo-American agricultural development and made particularly important contributions to cotton, indigo, tobacco, and staple food cultivation. The book also compellingly argues that the work experience of slaves shaped their views of the natural world. Broad in scope, clearly written, and at the center of current scholarly debates, Working the Diaspora challenges readers to alter their conceptual frameworks about Africans by looking at them as workers who, through the course of the Atlantic slave trade and plantation labor, shaped the development of the Americas in significant ways.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Frederick Knight\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    New York University Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0